import { PaymentFormDataFields, PaymentFormFieldType, PaymentFormValidationFields } from '../constants';
import { getPaymentFieldLabelText } from './getPaymentFieldLabelText';
import { getPaymentFieldErrorText } from './getPaymentFieldErrorText';

/**
 * Returns country field configs (name, labelText, placeHolderText, errors)
 * @param paymentForm Object of paymentFields and paymentErrors
 */
export var getLocalizedCountryFieldConfigs = function getLocalizedCountryFieldConfigs(paymentForm, paymentErrorModal) {
  var countryLabelText = getPaymentFieldLabelText(PaymentFormDataFields.COUNTRY, paymentForm);
  var countryPlaceHolderText = getPaymentFieldLabelText(PaymentFormDataFields.COUNTRY_PLACEHOLDER, paymentForm);
  var countryList = paymentForm === null || paymentForm === void 0 ? void 0 : paymentForm[PaymentFormFieldType.COUNTRY_LIST];
  var invalidError = getPaymentFieldErrorText({
    paymentForm: paymentForm,
    paymentErrorModal: paymentErrorModal,
    error: PaymentFormDataFields.INVALID_COUNTRY,
    requiredKey: '',
    invalidKey: PaymentFormValidationFields.INVALID_COUNTRY
  });
  return {
    name: 'country',
    labelText: countryLabelText,
    placeHolderText: countryPlaceHolderText,
    value: countryList,
    errors: {
      invalid: invalidError
    }
  };
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/internals/UserAddress/utils/getCountryFieldConfigs.js
// module id = 4552
// module chunks = 11